module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Griffin House regeneration – Prologis Park Luton",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--prologis-park-luton.netlify.app' : 'https://www.prologisgriffinhouseconsultation.co.uk',

    base: {
        "contact_address": "RTBU-HAYY-LCUX 7 Bayley Street, London WC1B 3HB",
        "contact_number": "020 7323 3544",
        "contact_email": "consultation@prologisgriffinhouseconsultation.co.uk"
    },

    holding: {
        "brand": "/assets/images/brand.png",
        "message": "Website coming soon"
    },

    meta: {
        "defaultSocialImage": "/assets/images/brand.png",
        "author": "Prologis",
        "description": "Griffin House regeneration – Prologis Park Luton",
        "gtag": "G-RBQFF4VZ1C",
        "gtm": "GTM-PRKBMHP"
    },

    form: {
        "contact": {
            "catcher_id": "",
            "recaptcha": "",
            "honeypot": ""
        },
        "feedback": {
            "catcher_id": "b4c34ee79c61f250dfb6c1cb1b74d2a1",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "37e803d9ebb59c0314a1f369418e06f0"
        }
    },

    consultation: {   
        "feedback_active": false, 
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "Thank you to everyone who provided comments on the proposals. All feedback submitted during the consultation was reviewed and considered by the project team ahead of the application being submitted.",

        "themes": [
            {
                "name": "Site & indicative layout",
                "url": "site-indicative-layout",
                "feedback_url": '',
                "icon": "site-indicative",
                "question": "Do you have any comments on the use of the site and the indicative site layout?",
                "key": "01-section"
            },
            {
                "name": "Highways & access",
                "url": "highways-access",
                "feedback_url": 'page-2/',
                "icon": "highways-access",
                "question": "Do you have any comments related to access and transport?",
                "key": "02-section"
            },
            {
                "name": "Sustainability & landscape",
                "url": "sustainability-landscape",
                "feedback_url": 'page-3/',
                "icon": "environment",
                
                "questions": [
                    {
                        "question": "Do you have any comments about sustainability or landscaping?",
                        "number": "3",
                    },
                    {
                        "question": "Do you have any comments related to building design and architecture?",
                        "number": "4",
                    },
                    {
                        "question": "Do you have any comments on our plans for a 'green link' and to open up the River Lea as it passes through the site?",
                        "number": "5",
                    }
                ],
                
                "key": "03-section"
            },
            {
                "name": "Community benefits",
                "url": "community-benefits",
                "feedback_url": 'page-4/',
                "icon": "community-benefits",
                "question": "Do you have any comments on the local and economic benefits, including skills and training opportunities?",
                "key": "04-section"
            },
        ]
    },

    downloads: [
        {
            "title": "Design & Access Statement (DAS) for the DC8 application",
            "url": "/assets/images/downloads/DAS-Phase-2.pdf"
        }
    ],
    
    faqs: [
        {
            "question": "1. Luton already has logistics and warehousing space. Why does it need more?",
            sections: [
                {
                    "text": "The proposals respond to a growing local and national demand for logistics and business space.  The way we shop, our use of e-commerce, and how goods and products move ‘from A to B’ have all changed, leading to businesses requiring more logistics and warehousing space in strategically connected locations."
                },
                {
                    "text": "The site is well-connected and strategically located for these operations, being less than one mile from London Luton Airport, near Luton Airport parkway railway station, located in the M1 logistics corridor and with exceptional road and rail links to the Greater London market and nationwide.  "
                },
                {
                    "text": "Better business space will also help Luton-based companies to thrive and provide significant benefits for the local area."
                }
            ]
        },
        {
            "question": "2. What are you applying for?",
            sections: [
                {
                    "text": "We’re preparing to submit a ‘hybrid’ planning application for the site to reflect the phased approach to developing the site.  A ‘detailed’ planning application will be submitted for Phase 1, while an ‘outline’ planning application will be brought forward for Phase 2, focused on the parameters of this part of the site.  Further detail for Phase 2 will be defined at a later date.  You can find out more and view an illustrative masterplan of the site showing the different phases on the ‘Site and indicative layout’ page of this website."
                }
            ]
        },
        {
            "question": "3. When are you submitting the planning application?",
            sections: [
                {
                    "text": "Our target is to submit the planning application in the summer of 2022, following the public consultation."
                }
            ]
        },
        {
            "question": "4. When would construction of the building start (if you get planning permission)?",
            sections: [
                {
                    "text": "The timetable is subject to securing planning permission but we are aiming to begin construction of Phase 1 (the part of the site for which we are seeking ‘detailed’ planning permission) by the end of 2022.  Our contractors will sign up to the Considerate Constructors Scheme and the construction programme will be sensitively planned to minimise any disruption on the local community."
                }
            ]
        },
        {
            "question": "5. How will the site be accessed? ",
            sections: [
                {
                    "text": "The main access point for vehicles will be off Windmill Road – both during construction and once operational – with a secondary access point proposed from Osborne Road.  Fewer access points are proposed when compared with the existing site.  This is because we want to minimise any potential impact on local roads.  The vast majority of vehicles entering and leaving the site will use the main access off Windmill Road because that is the most appropriate road for commercial vehicles."
                },

                {
                    "text": "We are also creating new pedestrian and cycle links through the site via a new green link alongside the River Lea."
                }
            ]
        },
        {
            "question": "6. What will the visual impact of the new buildings be on the surrounding area?",
            sections: [
                {
                    "text": "The illustrative masterplan has been carefully designed to put buildings in the most appropriate locations and to minimise the visual impact on neighbours and the surrounding area.  In certain parts of the site, we are setting back buildings from the site perimeter or intending to adjust heights to ensure the buildings integrate into the townscape.  In addition we will be using visual screening and landscaping, such as using retaining trees and creating a deep landscape border in certain parts on the site."
                }
            ]
        },
        {
            "question": "7. Will the new development be sustainable and how will you be helping the environment?",
            sections: [
                {
                    "text": "Prologis is committed to embedding sustainability into every aspect of its business operations and it has been at the forefront of every stage in the design process.  The development will be net zero carbon in construction, our buildings will be energy-efficient and we will be heavily encouraging future occupiers to follow our lead in reducing their carbon footprint.  We are also encouraging the use of sustainable travel choices with new cycle and pedestrian links within the site and new infrastructure such as cycle storage spaces and EV charging spaces.  More information of how we’re supporting the net zero agenda can be found on the ‘Sustainability and landscaping’ page of this website."
                }
            ]
        },
        {
            "question": "8. What benefits will there be for the local community?",
            sections: [
                {
                    "text": "Prologis Park Luton will deliver significant benefits to the local community as well as investment to help the town grow successfully and sustainably.  One of the key benefits will be a new ‘green link’ which we are creating through the site, establishing – for the first time – a public route for pedestrians and cyclists from Osborne Road to Manor Road Park along a re-landscaped River Lea.  We will be creating approximately 540 new jobs on site, more in the supply chain and we are looking into providing training and skills opportunities for local people.  View the ‘Community benefits’ page for more information on how the development will have a positive impact on the local area."
                }
            ]
        },
        {
            "question": "9. Are you doing anything to recognise the site’s former use as Vauxhall Motor headquarters?",
            sections: [
                {
                    "text": "The site’s story as the former Vauxhall Motors headquarters is a significant one and we’re interested to explore ways to celebrate it.  In other Prologis developments, we include installations, information boards and other features to help people appreciate the site.  We’re interested to see what ideas people have for Griffin House and what might be the best way to mark the site’s history within the context of its regeneration and redevelopment, so we’re inviting any comments on this as part of the consultation."
                }
            ]
        },
        {
            "question": "10.   How will feedback be used?",
            sections: [
                {
                    "text": "All comments and feedback submitted as part of our public consultation will be considered and used to inform the proposals, in line with the GDPR regulations.  We will prepare a report – a Statement of Community Engagement (SCE) – which will be submitted as part of the planning application."
                }
            ]
        },


    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: '',

    // Marker.io Key - replace this default key
    marker_io: '61faa07b77a791610a05ef5d'
};